import { StrictMode, startTransition } from "react"
import { hydrateRoot } from "react-dom/client"
import { HydratedRouter } from "react-router/dom"

/**
 * Client entry — hydrates the prerendered HTML.
 *
 * An explicit entry file is required: relying on the framework's implicit
 * default caused the hydration call to be tree-shaken out of the production
 * bundle (rolldown-vite), leaving prerendered pages without interactivity.
 */
startTransition(() => {
  hydrateRoot(document, (
    <StrictMode>
      <HydratedRouter />
    </StrictMode>
  ))
})
